import dates from "@/services/date";
import store from "@/store";
import company from "../../services/company";

let parseTime = function(value) {
  return dates.jsonDateToLocaleTime(value, company.getLocaleFormat(store.state));
};

export default {
  install: function (Vue) {
    Vue.filter('parseTime', parseTime);
  }
}
